export const HEADINGS = [
  ["code", "Tag ID"],
  ["name", "Tag Name"],
  ["category", "Tag Category"],
  ["status", "Status"],
];

export const searchMap = {
  "Tag ID": "code",
  "Tag Name": "name",
  "Tag Category": "category",
  "Tag Type": "type",
};

export const categoriesList = [
  {
    value: "Organisation",
    label: "Organisation",
  },
  {
    value: "Contact",
    label: "Contact",
  },
  {
    value: "Site",
    label: "Site",
  },
];
